import { STRAPI_FILTER_OPERATORS } from '../../constants';

import { isValidIndexSignature } from './isValidIndexSignature';

import type { RangeFields } from '../../types';
import type { FilterStateValue } from '../../types/filters';

export const createFromToFilterPart = (
  field: RangeFields,
  fromParam: FilterStateValue,
  toParam: FilterStateValue
) => {
  const fromFilter = isValidIndexSignature(fromParam)
    ? {
        from: { [STRAPI_FILTER_OPERATORS.GTE]: fromParam },
      }
    : {};

  const toFilter = isValidIndexSignature(toParam)
    ? {
        to: { [STRAPI_FILTER_OPERATORS.LTE]: toParam },
      }
    : {};

  if (fromFilter.from || toFilter.to) {
    return {
      [field]: Object.assign(fromFilter, toFilter),
    };
  }

  return undefined;
};

export default createFromToFilterPart;
